import React from "react";
import dynamic from "next/dynamic";
import { SummaryPlaceholder } from "../SummaryContainer/SummaryPlaceholder";
import { RelatedNewsPlaceholder } from "~components/RelatedNews/RelatedNewsPlaceholder";
import { BarChartsPlaceholder } from "~components/BarCharts/BarChartsPlaceholder";

export const BarCharts = dynamic(() => import("~components/BarCharts"), {
  ssr: false,
  loading: () => <BarChartsPlaceholder />,
});

export const CustomizableTicker = dynamic(
  () => import("@bloomberg/media-ui-markets").then((m) => m.CustomizableTicker),
  {
    loading: () => <p>Loading...</p>,
    ssr: false,
  }
);

export const RelatedNews = dynamic(() => import("~components/RelatedNews"), {
  loading: () => <RelatedNewsPlaceholder />,
  ssr: false,
});

export const SecurityList = dynamic(
  () => import("~components/SecurityList").then((mod) => mod.SecurityList),
  { ssr: false }
);

export const SetupWatchlist = dynamic(
  () => import("~components/SetupWacthlist").then((mod) => mod.default),
  { ssr: false }
);

export const SnapshotCharts = dynamic(
  () => import("~components/SnapshotCharts"),
  {
    ssr: false,
    loading: () => <SummaryPlaceholder />,
  }
);

export const SnapshotChart = dynamic(
  () =>
    import("@bloomberg/media-ui-markets").then(
      (module) => module.SnapshotChart
    ),
  { ssr: false }
);

export const DateRangeTickerChart = dynamic(
  () =>
    import("~components/TickerChart/composed/DateRangeTickerChart").then(
      (module) => module.default
    ),
  { ssr: false }
);

export const SparkLineTickerChart = dynamic(
  () =>
    import("~components/TickerChart/composed/SparkLine").then(
      (module) => module.default
    ),
  { ssr: false }
);
